// extracted by mini-css-extract-plugin
module.exports = {"container":"AppConfig_container_3qybL","text":"AppConfig_text_3xNKA","isFocus":"AppConfig_isFocus_3el1j","wrapper":"AppConfig_wrapper_Xqp19","layer":"AppConfig_layer_3IMVI"};